import React from "react";
import styles from "./styles.module.scss";

export const Companies = () => {
  return (
    <div className={styles.Companies}>
      <div className={styles.PageTitle}>
        <h1>Companies I Started</h1>
      </div>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>Replay</h2>
          <div className={styles.CompanyLogo}>
            <img src={require("../../assets/replay.png")} alt="Replay Logo" />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            I'm currently working on Replay. Replay makes life something that
            you can search. We're building a video wearable that captures
            important memories and makes them searchable with AI.
            <br />
            <br />
            Check it out here:{" "}
            <a
              href="https://runreplay.com/"
              className={styles.Link}
              target="_blank"
              rel="noopener noreferrer"
            >
              runreplay.com
            </a>
            .
          </p>
        </div>
      </section>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>CopyCat</h2>
          <div className={styles.CompanyLogo}>
            <img
              src={require("../../assets/copycat.jpeg")}
              alt="CopyCat Logo"
            />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            Went through YC's W25 batch. Spent a year pivoting between browser
            agents, RPA, dermatology, and a handful of other ideas. Learned a
            lot this year.
            <br />
            <br />
            Raised money from Y Combinator, Flex Capital, and Breakpoint
            Capital.
          </p>
        </div>
      </section>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>Platter</h2>
          <div className={styles.CompanyLogo}>
            <img
              src={require("../../assets/platter.jpeg")}
              alt="Platter Logo"
            />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            I was the co-founder of Platter, a company that provided websites
            and mobile apps to hundreds of mom & pop restaurants across the west
            coast. We offered a platform that allowed owners to manage their
            menus, loyalty programs, and entire digital presence with Platter.
            <br />
            <br />I started Platter when a friend of mine who owned a Moroccan
            restaurant wanted a website and app just like the McDonald's one.
            That grew into a full fledged restaurant management platform. Once
            we decided to pivot to CopyCat, we automated all the company's
            operations and continue to run it as a lifestyle company.
          </p>
        </div>
      </section>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>Course Finder</h2>
          <div className={styles.CompanyLogo}>
            <img
              src={require("../../assets/course-finder.jpeg")}
              alt="Course Finder Logo"
            />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            While at the University of Washington, I built Course Finder, the
            most used course research platform at UW, powering the course
            research process for 10,000 students every quarter. Students could
            lookup courses and see the average GPAs of given courses as well as
            specific professors. We also cross-referenced the data with
            RateMyProfessor review data to give students the most accurate
            picture of a course before taking it. <br />
            <br />
            We ran the platform for 4 quarters before ultimately moving on since
            I was about to graduate & the lack of monetization of the platform.
            A month after we shut it down, the university came out with their
            own version of the product.
          </p>
        </div>
      </section>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>Pondr</h2>
          <div className={styles.CompanyLogo}>
            <img src={require("../../assets/pondr.jpeg")} alt="Pondr Logo" />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            I joined the small Pondr team as an engineer. Pondr was one of the
            first 100 companies to get access to GPT-3. We built a platform that
            allowed Amazon sellers to perform Q&A on their product reviews.{" "}
            <br />
            <br />
            This experience was the most valuable because it's where I met my
            great co-founders for future companies, Graham Sabin, and Abhi
            Balijepalli. I left Pondr as I had decided to focus on getting some
            industry experience before coming back to startups.
          </p>
        </div>
      </section>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>Help</h2>
          <div className={styles.CompanyLogo}>
            <img src={require("../../assets/help.jpeg")} alt="Help Logo" />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            Help was a mobile app where users could request home services from
            nearby providers. This was prior to Thumbtack and TaskRabbit getting
            popular. For some context on how this went, I was in high school.{" "}
            <br />
            <br />A few childhood friends and I managed to get a few customers
            and build a small team. We brought a product to market & I learned
            how to lead a team.
          </p>
        </div>
      </section>

      <section className={styles.Company}>
        <div className={styles.CompanyHeader}>
          <h2>Quran Connect</h2>
          <div className={styles.CompanyLogo}>
            <img
              src={require("../../assets/quran-connect.jpeg")}
              alt="Quran Connect Logo"
            />
          </div>
        </div>
        <div className={styles.Content}>
          <p>
            Quran Connect was a platform that helped manage classes within
            Mosques. It was used by Quran teachers and local scholars in the
            community where I grew up.
            <br />
            <br />
            This was the first time I ever built anything used by anyone. I had
            a lot of great mentors here and was building alongside close
            friends. It was incredibly fun.
          </p>
        </div>
      </section>
    </div>
  );
};
